import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-vstore',
  templateUrl: './vstore.component.html',
  styleUrls: ['./vstore.component.scss'],
  standalone: false
})
export class VStoreComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'overview';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Key Features', icon: 'bx-star' },
    { id: 'categories', label: 'Offer Categories', icon: 'bx-category' },
    { id: 'experience', label: 'User Experience', icon: 'bx-user-circle' },
  ];

  highlights = [
    { icon: 'bx-coin-stack', label: 'Miles Redemption', desc: 'Drivers redeem accumulated Varroc Miles directly in the app for partner offers and exclusive deals.' },
    { icon: 'bx-show', label: 'Real-Time Balance', desc: 'Live visibility of available miles and complete redemption history with transaction-level breakdowns.' },
    // { icon: 'bx-calendar-star', label: 'Campaign Listings', desc: 'Featured campaign listings and limited-time offers from OEM partners and brand sponsors.' },
    { icon: 'bx-lock-alt', label: 'Secure Redemption', desc: 'Encrypted redemption flows with OTP verification and partner voucher delivery via secure channels.' },
    { icon: 'bx-collection', label: 'Curated Catalogue', desc: 'Organized product and service catalogue with category filters, search, and relevance ranking.' },
    { icon: 'bx-refresh', label: 'Auto-Refresh', desc: 'Store content refreshed in real time as new campaigns launch, offers expire, or stock updates.' },
  ];

  categories = [
    { icon: 'bx-car', title: 'Auto Services', desc: 'Service discounts, accessories, and spare parts from OEM-authorized partners.' },
    { icon: 'bx-restaurant', title: 'Food & Lifestyle', desc: 'Partner brand vouchers for food delivery, dining, and lifestyle services.' },
    { icon: 'bx-phone', title: 'Digital & Recharge', desc: 'Mobile recharges, digital subscriptions, and OTT platform credits.' },
    { icon: 'bx-gas-pump', title: 'Travel & Fuel', desc: 'Fuel cashback, toll discounts, and travel-related partner rewards.' },
    { icon: 'bx-health', title: 'Health & Wellness', desc: 'Pharmacy discounts, health app subscriptions, and insurance benefits.' },
    { icon: 'bx-package', title: 'E-Commerce', desc: 'Cashback and discount coupons for leading e-commerce and retail platforms.' },
  ];

  experienceSteps = [
    { step: '01', label: 'Browse Store', desc: 'Driver opens V-Store in the app and browses available offers by category or search.' },
    { step: '02', label: 'Select Offer', desc: 'Selects a reward and sees the miles required, offer details, and validity period.' },
    { step: '03', label: 'Confirm Redemption', desc: 'Verifies identity and confirms the redemption — miles are deducted instantly.' },
    { step: '04', label: 'Receive Reward', desc: 'Voucher or coupon is delivered in-app and via notification for immediate use.' },
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
